import { CASE_STUDIES } from "@/lib/data";

const CaseStudies = () => {
  return (
    <section className="py-24 lg:py-32 bg-white" data-testid="case-studies-section">
      <div className="container-tm">
        <div className="grid lg:grid-cols-12 gap-10 mb-16 items-end">
          <div className="lg:col-span-7">
            <span className="overline">Quelques études de cas</span>
            <h2 className="mt-5 font-serif font-light text-ink text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
              Des exemples
              <span className="italic text-gold"> concrets</span>.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="font-sans text-base md:text-lg text-ink/65 leading-relaxed">
              Le potentiel de votre logement dépend de nombreux facteurs : emplacement, saisonnalité, qualité des photos, prix, avis voyageurs et équipements. Nous mettons notre savoir-faire à votre disposition pour optimiser vos revenus.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {CASE_STUDIES.map((c, i) => (
            <article
              key={c.name}
              data-testid={`case-study-${i}`}
              className="group bg-cream/40 rounded-3xl overflow-hidden border border-ink/5 hover:shadow-lift transition-shadow duration-500 flex flex-col"
            >
              <div className="aspect-[4/5] overflow-hidden">
                <img
                  src={c.image}
                  alt={`${c.name} – ${c.type}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-7 lg:p-8 flex flex-col flex-1 bg-white">
                <div className="flex items-center justify-between mb-3">
                  <span className="overline">Étude · 0{i + 1}</span>
                  <span className="number-circle">{c.capacity.split(" ")[0]}p</span>
                </div>
                <h3 className="font-serif text-3xl text-ink mb-3 leading-tight">{c.name}</h3>
                <p className="font-sans text-sm text-ink/65 leading-relaxed mb-5 flex-1">
                  {c.description}
                </p>
                <div className="border-t border-ink/10 pt-4 space-y-1">
                  <p className="font-sans text-sm text-ink/85 font-medium">{c.type}</p>
                  <p className="font-sans text-xs text-ink/55">Capacité : {c.capacity}</p>
                </div>
                <div className="mt-5 bg-ink text-white rounded-2xl p-5">
                  <p className="text-[10px] uppercase tracking-[0.22em] text-white/55 font-semibold mb-1">
                    Revenu après commission
                  </p>
                  <p className="font-serif text-3xl text-gold leading-tight">{c.revenue}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;
